<div
    class="back-to-top-wrapper"
    [class.back-to-top-btn-show]="showBackToTopBtn">
    <i class="bi bi-chevron-up text-white fs-5 lh-sm"></i>

    <button
        id="back_to_top"
        type="button"
        class="back-to-top-btn fs-7 text-white"
        (click)="scrollToTop()">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="#FFFFFF"
            class="bi bi-chevron-up me-2"
            viewBox="0 0 16 16">
            <path
                fill-rule="evenodd"
                d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
        </svg>
        <span>Back to Top</span>
    </button>
</div>
